module.exports = "<chat-users [users]=\"users\"></chat-users>\n<chat-body [messages]=\"messages\"></chat-body>\n<chat-form></chat-form>\n"